/* eslint-disable prettier/prettier */
/* Project Details Page will be imported from here */
import SubmittalDetailspage from "./submittal-landing-page";

export default SubmittalDetailspage;
